export const INVESTIGATION_HISTORY_DRAWER_KEY = "investigation-history";

export const INVESTIGATION_HISTORY_PANEL_COLLAPSED_WIDTH_PX = 60;

export const INVESTIGATION_HISTORY_PANEL_EXPANDED_WIDTH_PX = 324;

export const INVESTIGATION_HISTORY_PANEL_SCROLL_AREA_SELECTOR =
  "[data-investigation-history-scroll-area]";

export const INVESTIGATION_HISTORY_PANEL_SCROLL_AREA_TEST_ID =
  "investigation-history-panel-scroll-area";

export const INVESTIGATION_HISTORY_PANEL_SCROLLBAR_TRACK_INSET_PX = 8;

export const INVESTIGATION_HISTORY_PANEL_SCROLLBAR_MIN_THUMB_HEIGHT_PX = 24;

export const INVESTIGATION_HISTORY_PANEL_RECENCY_HEADER_ROW_HEIGHT_PX = 26;

export const INVESTIGATION_HISTORY_CARD_ROW_HEIGHT_PX = 82;

/** Gap between a recency header and its cards, and between section cards and the next header. */
export const INVESTIGATION_HISTORY_PANEL_SECTION_GAP_PX = 8;

/**
 * Height of the sticky recency header overlay at the top of the list scrollport.
 * Matches the virtualized header row size (label row + section gap).
 */
export const INVESTIGATION_HISTORY_PANEL_STICKY_HEADER_OVERLAY_HEIGHT_PX =
  INVESTIGATION_HISTORY_PANEL_RECENCY_HEADER_ROW_HEIGHT_PX +
  INVESTIGATION_HISTORY_PANEL_SECTION_GAP_PX;

/**
 * Prefetch the next investigations page when the scrollport is within this
 * distance of the bottom (roughly two card rows of lead time).
 */
export const INVESTIGATION_HISTORY_PANEL_FETCH_NEXT_PAGE_THRESHOLD_PX = 200;
